import { Injectable } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import { datiqAmcharts5SetColor } from './models';

@Injectable({
    providedIn: 'root',
})
export class DatiqAmcharts5UtilsService {
    constructor() {}

    setColor(hexColor: string): am5.Color {
        return datiqAmcharts5SetColor(hexColor);
    }
}
